import dayjs, { ConfigType } from 'dayjs';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { formatDateTime, getTimezoneDetails } from '../utils/date-helpers';
import { useIsUserOutsideOfficeTimezone } from './use-is-user-outside-office-timezone';
import { useSchedulingLocationInfo } from './use-scheduling-location-info';

export const useLocationTimezone = (locationId = '') => {
  const { isScheduleV3FlagEnabled } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();
  const { getLocationTimeZone } = useSchedulingLocationInfo();
  const isUserOutsideTimezone = useIsUserOutsideOfficeTimezone();

  const userTimezone = dayjs.tz.guess();
  const locationTimezone = getLocationTimeZone(locationId);
  const timezoneDetails = getTimezoneDetails(locationTimezone);
  const locationTimezoneAbbr = (isScheduleV3FlagEnabled && isUserOutsideTimezone && timezoneDetails.abbr) || '';

  const formatDateAndTime = (dateTime: ConfigType, format: string, showTimezoneAbbr = false) => {
    const formattedDateTime = formatDateTime(dateTime, {
      fromTimezone: 'UTC',
      toTimezone: isScheduleV3FlagEnabled ? locationTimezone : userTimezone,
      outputFormat: format,
    });

    // Show timezone abbreviation only if the user is outside the location's timezone and v3 is enabled
    return showTimezoneAbbr ? `${formattedDateTime} ${locationTimezoneAbbr}`.trim() : formattedDateTime;
  };

  return { formatDateAndTime, locationTimezoneAbbr };
};
